import { Injectable } from '@angular/core';
import { DispatchedServiceSyncDataDto } from '../../models/dtos/dispatched-service-sync-data.dto';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoggerService } from 'src/app/telemetry/logger.service';

/**
 * Service used to manipulate dispatched service sync data
 */
@Injectable({
	providedIn: 'root'
})
export class DispatchedServicesSyncDataDataService {

	/*
	* The path to the dispatched services sync controller.
	*/
	private static readonly CONTROLLER_PATH: string = "/api/dispatchedservicessyncdata";

	/** The name of the HTTP header for the sync data. */
	public static readonly SYNC_DATA_HEADER_NAME: string = "crown-x-sync-data";

	/**
	 * @constructor
	 *
	 * @param httpClient The HTTP client to use for web requests.
	 * @param logger The logging service.
	 */
	constructor(
		private readonly httpClient: HttpClient,
		private readonly logger: LoggerService
	) { }

	/**
	 * Saves sync data for a service for the current driver
	 * @param service The sync data for a service to send
	 * @returns An observable to indicate when the process is done
	 */
	public Save$(service: DispatchedServiceSyncDataDto): Observable<void> {
		try {
			const url: string = `${DispatchedServicesSyncDataDataService.CONTROLLER_PATH}`;
			let syncHeaders: HttpHeaders = new HttpHeaders();
			syncHeaders = syncHeaders.append(DispatchedServicesSyncDataDataService.SYNC_DATA_HEADER_NAME, service.LegacyId.toString());

			return this.httpClient.post<void>(url, service, {
				headers: syncHeaders,
				withCredentials: true
			});
		}
		catch (error: any) {
			this.logger.TrackError("Unable to build sync service request.", error);
			return throwError(() => error);
		}
	}
}
